/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For more information visit: https://egtuniverse.com/legal
 *
 * Created for Universe App Tools.
 *
 * Created by Justin K Kazmierczak.
 */
var _ = require("../../../uam/module.js")(module.exports, {
    namespace: "email.footer",
    title: "Email Footer",
    description: "Gray footer box with transactional message and legal links for platform emails.",
    supportServer: true,
    control: false,
    foruseIn: ["email"],
    fields: {
        "transactional": {
            title: "Transactional",
            type: "boolean",
            description: "When true, shows a note explaining this is a security/transactional email. When false, a default unsubscribe mesage and link is shown instead.",
            required: false,
            default: true
        },
        "message": {
            title: "Message",
            type: "string",
            description: "The footer message explaining why the user received this email.",
            required: false,
            default: ""
        }
    }
});

var $ = require("../../../uam/scafolding.js");

exports.render = async function (options) {
    var { html } = await exports.renderEmail(options);
    return [{
        n: "ua.element.serverNotSupported",
        inner: {
            n: "json",
            type: "ua/interface",
            by: "email.footer",
            i: JSON.stringify({
                n: "html",
                html: `<div style="max-width:480px;margin:0 auto;font-family:Arial,Helvetica,sans-serif;">${html}</div>`
            })
        }
    }];
};

exports.renderEmail = async function (options) {
    var transactional = (options && typeof options.transactional !== "undefined") ? options.transactional : true;
    var message       = (options && options.message) ? options.message : "";
    var cfg = $.config;
    var appUrl    = (cfg.my && cfg.my.app && cfg.my.app.url) ? cfg.my.app.url.replace(/\/$/, "") : "";
    var appName   = (cfg.my && cfg.my.app && cfg.my.app.name) ? cfg.my.app.name : "The Universe";
    var legalUrl  = "https://egtuniverse.com/legal";
    var privacyUrl = "https://egtuniverse.com/legal/privacy";
    var universeUrl = "https://egtuniverse.com/";
    var logoUrl = "https://egtuniverse.com/logo.png";

    var transactionalNote = "";
    var textTransactionalNote = "";
    if (transactional) {
        transactionalNote = `<p style="margin:0 0 8px 0;padding:0;font-family:Arial,Helvetica,sans-serif;font-size:12px;color:#6C757D;">
      This is a transactional or security email. You cannot unsubscribe from these types of emails as they are not a subscription.
    </p>`;
        textTransactionalNote = "This is a transactional or security email. You cannot unsubscribe from these types of emails as they are not a subscription.\n";
    }

    var messageHtml = message
        ? `<p style="margin:0 0 8px 0;padding:0;font-family:Arial,Helvetica,sans-serif;font-size:12px;color:#6C757D;">${message}</p>`
        : "";


    var unsubscribeHtml = !transactional
        ? `<p style="margin:0 0 8px 0;padding:0;font-family:Arial,Helvetica,sans-serif;font-size:12px;color:#6C757D;">
      You can <a href="${appUrl}/email/unsubscribe" style="color:#6C757D;text-decoration:underline;">unsubscribe</a> from these emails if you no longer wish to receive them. If you have an account, for security, you will be asked to login to manage your email preferences.
    </p>`
        : "";
    var textUnsubscribe = !transactional
        ? `You can unsubscribe from these emails if you no longer wish to receive them: ${appUrl}/email/unsubscribe\n`
        : "";

    var html = `<tr>
  <td style="padding:20px;">
    <table width="100%" border="0" cellpadding="0" cellspacing="0"
           style="background:#1A1A1A;border-radius:4px;">
      <tr>
        <td style="padding:20px;">
          ${messageHtml}
          ${transactionalNote}
          ${unsubscribeHtml}
          <p style="margin:0 0 10px 0;padding:0;text-align:center;font-family:Arial,Helvetica,sans-serif;font-size:14px;color:#FFFFFF;">
            Powered by
            <a href="${universeUrl}" style="color:#FFFFFF;text-decoration:none;border:none;outline:none;">
              <img src="${logoUrl}" alt="EGT Universe Logo TM" width="16" height="16" style="border:none;outline:none;display:inline-block;vertical-align:text-bottom;width:16px;height:16px;">
              The EGT Universe.
            </a>
          </p>
          <p style="margin:0;padding:0;font-family:Arial,Helvetica,sans-serif;font-size:12px;color:#6C757D;">
            Subject to The Universe
            <a href="${legalUrl}" style="color:#6C757D;text-decoration:underline;">Terms of Service</a>
            &amp;
            <a href="${privacyUrl}" style="color:#6C757D;text-decoration:underline;">Privacy Policy</a>.
          </p>
          <p style="margin:8px 0 0 0;padding:0;font-family:Arial,Helvetica,sans-serif;font-size:12px;color:#6C757D;">
            &copy; ${new Date().getFullYear()} ${appName}. All rights reserved.
          </p>
        </td>
      </tr>
    </table>
  </td>
</tr>`;

    var text = [
        message || "",
        textTransactionalNote,
        textUnsubscribe,
        "Powered by The EGT Universe.",
        `Terms of Service: ${legalUrl}`,
        `Privacy Policy: ${privacyUrl}`,
        `\u00A9 ${new Date().getFullYear()} ${appName}. All rights reserved.`
    ].filter(function(s) { return s.trim() !== ""; }).join("\n");

    return { html, text };
};
